import template from './customer-mapping.html';
import controller from './customer-mapping.controller';

let customerMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default customerMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/customer-mapping/customer-mapping.component.js